import Node from './node';

export default class ForEachAnswer extends Node {
  clone() {
    return new ForEachAnswer(this.text, this.attributes, this.children.map((c) => c.clone()));
  }
}
